import { mapState, mapActions } from 'vuex';

export const utilities = {
	computed: {
		...mapState([
			'backgroundColor',
			'currentKey',
			'endRound',
			'endGame',
			'difficult',
			'gamemode',
			'isPreCounting',
			'soundsStatus',
			'sounds',
		]),
	},
	methods: {
		...mapActions(['updateProperty','playAudio']),
			playAudio(audio, reset = false) {
				if(reset) {
					for (let sound in this.$store.state.sounds) {
						this.$store.state.sounds[sound].pause();
						this.$store.state.sounds[sound].currentTime = 0;
						this.$store.state.sounds[sound].playbackRate = 1;
					}
				}
				if(this.$store.state.soundsStatus) {
					this.$store.state.sounds[audio].play();
				}
			}
		},
		
};
